import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

import Button from "ui/Button";
import LeftIcon from "assets/svg/left-arrow.svg";
import RightIcon from "assets/svg/right-arrow.svg";

export function DialogStepperActions(props) {
  const {
    isFirstStep,
    isLastStep,
    handleBack,
    onClose,
    isLoading,
    preLoading,
    ariaLabelledby = "dialog",
  } = props;

  const renderBackButton = () => {
    if (isFirstStep) return;

    return (
      <Button
        id="stepper-back-button"
        startIcon={<LeftIcon width="20px" />}
        color="surface"
        onClick={handleBack}
        disabled={preLoading}
        variant="subAction"
        sx={{ padding: "8px 24px 8px 14px" }}
      >
        Back
      </Button>
    );
  };

  const renderNextButton = () => {
    if (isLastStep) return;
    return (
      <Button
        id="stepper-next-button"
        endIcon={<RightIcon width="20px" />}
        type="submit"
        disabled={preLoading}
        sx={{ padding: "8px 14px 8px 24px" }}
        variant="contained"
      >
        Next
      </Button>
    );
  };

  const renderCancelButton = () => (
    <Button id="stepper-cancel-button" variant="text" onClick={onClose}>
      Cancel
    </Button>
  );

  const renderSaveButton = () => {
    if (!isLastStep) return;
    return (
      <Button
        id={`${ariaLabelledby.toLowerCase()}_submit`}
        loading={isLoading}
        type="submit"
        disabled={preLoading}
      >
        Save
      </Button>
    );
  };

  return (
    <>
      {renderBackButton()}
      <MainActionsContainer>
        {renderCancelButton()}
        {renderNextButton()}
        {renderSaveButton()}
      </MainActionsContainer>
    </>
  );
}

const MainActionsContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  alignSelf: "stretch",
  gap: "8px",
  flex: "1 0 0",
}));

DialogStepperActions.propTypes = {
  onClose: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isFirstStep: PropTypes.bool,
  isLastStep: PropTypes.bool,
  preLoading: PropTypes.bool,
  ariaLabelledby: PropTypes.string,
};
